/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CallbackTimeslotDto } from '../models/CallbackTimeslotDto';
import type { NumberOfContacts } from '../models/NumberOfContacts';
import type { PatientDto } from '../models/PatientDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { request as __request } from '../core/request';

export class CallbackTimeslotService {

    /**
     * create callbackTimeslot
     * @param id
     * @param requestBody
     * @returns PatientDto
     * @throws ApiError
     */
    public static callbackTimeslotControllerCreateCallbackTimeslot(
        id: string,
        requestBody: CallbackTimeslotDto,
    ): CancelablePromise<PatientDto> {
        return __request({
            method: 'POST',
            path: `/callback-timeslot/${id}/callbackTimeslot`,
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * update referral callbackTimeslot
     * @param id
     * @param requestBody
     * @returns CallbackTimeslotDto
     * @throws ApiError
     */
    public static callbackTimeslotControllerUpdateCallbackTimeslot(
        id: number,
        requestBody: CallbackTimeslotDto,
    ): CancelablePromise<CallbackTimeslotDto> {
        return __request({
            method: 'PATCH',
            path: `/callback-timeslot/callbackTimeslot/${id}`,
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * deactivate referral callbackTimeslot
     * @param id
     * @returns any
     * @throws ApiError
     */
    public static callbackTimeslotControllerDeactivateCallbackTimeslot(
        id: number,
    ): CancelablePromise<any> {
        return __request({
            method: 'PATCH',
            path: `/callback-timeslot/deactivate/${id}`,
        });
    }

    /**
     * Increment number of contacts per contact time slot
     * @param referralId
     * @returns NumberOfContacts
     * @throws ApiError
     */
    public static callbackTimeslotControllerIncrementContactCounter(
        referralId: string,
    ): CancelablePromise<NumberOfContacts> {
        return __request({
            method: 'PATCH',
            path: `/callback-timeslot/increment-contact-counter/${referralId}`,
        });
    }

    /**
     * Get number of contacts per contact time slot
     * @param referralId
     * @returns NumberOfContacts
     * @throws ApiError
     */
    public static callbackTimeslotControllerNumberOfContacts(
        referralId: string,
    ): CancelablePromise<NumberOfContacts> {
        return __request({
            method: 'GET',
            path: `/callback-timeslot/number-of-contacts/${referralId}`,
        });
    }

}